/**
 * index
 */
export * from './src/index';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-inputs/node_modules/@syncfusion/ej2-base/index.js
// module id = ./node_modules/@syncfusion/ej2-inputs/node_modules/@syncfusion/ej2-base/index.js
// module chunks = vendor